import { Toast } from "../custom/toast/index";

// Exibe as mensagens de flash (shared/_flash) como toasts do SweetAlert2.
export function initFlashToasts() {
  document.querySelectorAll(".flash-message").forEach((el) => {
    const icon = el.dataset.flashIcon || "info";
    const message = el.dataset.flashMessage;
    if (message) {
      Toast.fire({ icon: icon, text: message });
    }
    el.remove();
  });
}
